export default {
  // No-auth Page Paths
  root: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  recoverAccount: '/recover-account',
  invited: '/invited',
  signup: '/signup',

  // New customer onboarding flow (generic for all customers)
  customerOnboarding: '/customer-onboarding',
  accountSetup: '/account-setup',

  // Customer Product/Authenticated Paths
  account: '/account',
  payoutSetup: '/account/payouts/setup',
  payoutStatus: '/account/payouts/status',
  manageSubscription: '/manage-subscription/:id',
  cidCancellationRequest: '/cid-cancellation-request',
  planUpgrade: '/plan-upgrade',
  users: '/users',
  settings: '/settings/:id',
  teamsSettings: '/settings/teams',
  unitsSettings: '/settings/units',
  fingerprintingSettings: '/settings/fingerprinting',
  productNewSearch: '/new',
  productResultsUpload: '/upload-results',
  productReview: '/review',
  productListSearches: '/searches/:status',
  productSearchResults: '/results/:id',
  productInfringements: '/infringements',
  productConfirmedRemovals: '/confirmed-removals',
  productResultsDetails: '/infringements/:resultId',
  productPiracyOverview: '/piracy-overview',
  productReports: '/reports',
  productReport: '/reports/:id',
  sharedReport: '/shared-report',
  productLiveTracker: '/live-tracker',
  productListAssets: '/content-id/assets',
  productAssetDetails: '/content-id/assets/:id',
  productAssetUpload: '/content-id/assets/upload',
  productAssetUploadDetails: '/content-id/assets/upload/:id',
  productClaimsList: '/content-id/assets/:assetId/claims',
  productAllClaimsList: '/content-id/claims',
  productManualClaimSubmit: '/content-id/manual-claims/submit',
  productManualClaimRequest: '/content-id/manual-claims/:id',
  productClaimDetails: '/content-id/claims/:id',
  productCidAllowlist: '/content-id/cid-allowlist',
  creatorReferrals: '/content-id/referrals',
  // Admin Paths
  // When adding new admin paths, please update NAV_SECTIONS in AdminNavWrapper.jsx.
  adminLogin: '/admin/login',
  adminAccount: '/admin/account',
  adminSearches: '/admin/searches',
  adminSearchResults: '/admin/searches/:id',
  adminResults: '/admin/results',
  adminCompliance: '/admin/compliance',
  adminFileImportsHistory: '/admin/file-imports/history',
  adminFileImportNew: '/admin/file-imports/new/:id?',
  adminCreateSearchesImport: '/admin/file-imports/searches',
  adminManualClaims: '/admin/content-id/manual-claims',
  adminManualClaimRequest: '/admin/content-id/manual-claims/:id',
  adminMonetizationRequests: '/admin/content-id/monetization-requests',
  adminMonetizationRequestDetails: '/admin/content-id/monetization-requests/:id',
  adminPayoutDashboard: '/admin/content-id/payouts',
  adminCidPayoutStatus: '/admin/content-id/payout-setup-status',
  adminCidAnalytics: '/admin/content-id/analytics',
  adminYtAudits: '/admin/content-id/yt-audits',
  adminCustomOnboarding: '/admin/custom-onboarding',
  adminOnboardings: '/admin/onboardings',
  adminOnboardingDetails: '/admin/onboardings/:id',
  // Nagra Paths
  adminNagraManageOperations: '/admin/nagra/manage-operations',
  adminNagraCandidateDetail: '/admin/nagra/review-candidates/:id',
  adminNagraManualSubmission: '/admin/nagra/manual-submission',
  adminNagraReviewCandidates: '/admin/nagra/review-candidates',
  adminDemoLinks: '/admin/demo-links',
  adminDemoSubmissions: '/admin/demo-links/:linkId/submissions',
  demoLanding: '/demo/:token',
  demoSplash: '/demo/splash',
  // Cyclops Paths (deprecated, mostly for demo purposes)
  cyclopsAnalytics: '/cyclops/analytics',
  cyclopsEventsList: '/cyclops/events/:status',
  cyclopsEventDetails: '/cyclops/events/results/:id',
  cyclopsSettings: '/cyclops/settings',
  cyclopsOrganizations: '/cyclops/organizations',
};
